import classNames from 'classnames';
import { Container } from 'yoso';
import { AssetStatusCard } from '~/components/Asset/Status/Card/AssetStatusCard';
import { useChallengeEvent } from '~/components/Challenge/Challenge.hooks';
import { ChallengeScoreStatus } from '~/components/Challenge/Status/Score/ChallengeScoreStatus';
import { QueryErrorBoundary } from '~/components/Error';
import { HomeChallenge } from '~/components/Home/Challenge/HomeChallenge';
import { CommunityCta } from '~/components/Home/Community/CommunityCta';
import { HomeHero } from '~/components/Home/Hero/HomeHero';
import { HomeSecurity } from '~/components/Home/HomeSecurity';
import { HomeDropShopErrorFallback } from '~/components/Home/Store/Error/HomeDropShopErrorFallback';
import { HomeDropShop } from '~/components/Home/Store/HomeDropShop';
import { MarketplaceExplorer } from '~/components/Marketplace/Explorer/MarketplaceExplorer';
import { useMember } from '~/components/Member/Member.hooks';
import { Page } from '~/components/Page';
import { Section } from '~/components/Page/Section/Section';
import { QuickMenu } from '~/components/Quick/Menu/QuickMenu';
import styles from './HomePage.module.scss';

// TODO: Remove challenge UI after challenge is completely over.
export const HomePage = () => {
  const {
    data: { isLoggedIn, region },
  } = useMember();

  const { data } = useChallengeEvent();

  return (
    <HomeSecurity>
      <Page className={classNames(styles.root, 'home-page')} data-event-page_name="Home">
        <Section className={styles.heroSection}>
          <Container margin="auto">
            <HomeHero />
          </Container>
        </Section>
        {data.challengeStatus !== 'CLOSED' && (
          <Section className={styles.challengeSection}>
            <Container margin="auto">
              <HomeChallenge className={styles.challenge} />
            </Container>
          </Section>
        )}
        <Section className={styles.quickMenuSection}>
          <Container margin="auto">
            <QuickMenu />
            {isLoggedIn && (
              <QueryErrorBoundary>
                <AssetStatusCard className={styles.assetStatus} />
              </QueryErrorBoundary>
            )}
          </Container>
        </Section>
        {isLoggedIn && data.challengeStatus !== 'CLOSED' && region !== 'US' && (
          <QueryErrorBoundary>
            <Section>
              <Container margin="auto">
                <ChallengeScoreStatus />
              </Container>
            </Section>
          </QueryErrorBoundary>
        )}
        <Container margin="auto">
          <Section>
            <MarketplaceExplorer />
          </Section>
          <QueryErrorBoundary FallbackComponent={HomeDropShopErrorFallback}>
            <Section>
              <HomeDropShop className="home-drop-shop" />
            </Section>
          </QueryErrorBoundary>
        </Container>
        <Section className={styles.communitySection}>
          <Container margin="auto">
            <CommunityCta />
          </Container>
        </Section>
      </Page>
    </HomeSecurity>
  );
};
